// extracted by mini-css-extract-plugin
export var cartContainer = "_m6-4";
export var gray = "_m6-1";
export var itemContainer = "_m6-2";
export var itemDetails = "_m6-3";
export var strong = "_m6-0";